import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import { toast } from "react-toastify";


const UserProfilePage: React.FC = () => {
  // Simulamos los datos de usuario
  const [userData, setUserData] = useState({
    firstName: "John",
    lastName: "Doe",
    phone: "1234567890",
    address: "123 Main St",
    city: "Springfield",
    province: "Illinois",
    country: "USA",
    email: "john.doe@example.com",
    username: "johndoe",
    password: "contraseña",
  });
  
    const [isLoading, setIsLoading] = useState(false);
  
    useEffect(() => {
      // Simulación de carga de datos del usuario (realizar llamada a la API aquí)
      const fetchUserData = async () => {
        const data = {
          firstName: 'Juan',
          lastName: 'Pérez',
          phone: '123456789',
          address: 'Calle Falsa 123',
          city: 'Ciudad Ejemplo',
          province: 'Provincia Ejemplo',
          country: 'País Ejemplo',
          email: 'juan.perez@example.com',
          username: 'juanperez',
          password: '', // No se debe prellenar
        };
        setUserData(data);
      };
  
      fetchUserData();
    }, []);
  
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;
      setUserData((prevData) => ({ ...prevData, [name]: value }));
    };
  
    const handleSave = async () => {
      setIsLoading(true);
      try {
        // Simulación de llamada para guardar cambios
        // Aquí iría un fetch/axios a tu endpoint
        await new Promise((resolve) => setTimeout(resolve, 2000)); // Simula la espera
  
        toast.success('Datos actualizados correctamente', {
          position: 'top-right',
        });
      } catch (error) {
        toast.error('Error al guardar los cambios', {
          position: 'top-right',
        });
      } finally {
        setIsLoading(false);
      }
    };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start", // Alineamos hacia arriba
        height: "85vh",
        backgroundColor: "#f5f5f5",
        padding: 2,
        marginTop: "0px", // Margen para evitar que se superponga con el navbar

      }}
    >
      <Card
        sx={{
          marginTop: "15px",
          width: "100%",
          maxWidth: 800,
          borderRadius: 4,
          boxShadow: 3,

        }}
      >
        <CardContent>
          <Typography
            variant="h4"
            align="center"
            gutterBottom
            sx={{ color: "#1976d2", fontWeight: "bold" }}
          >
            Perfil de Usuario
          </Typography>

          {/* Usamos Box en lugar de Grid */}
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 3, // Espacio entre los campos
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="Nombre"
                value={userData.firstName}
                name="firstName"
                onChange={handleInputChange}
                
              />
            </Box>
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="Apellido"
                value={userData.lastName}
                name="lastName"
                onChange={handleInputChange}
                
              />
            </Box>
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="Teléfono"
                value={userData.phone}
                name="phone"
                onChange={handleInputChange}
              />
            </Box>
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="Dirección"
                value={userData.address}
                name="address"
                onChange={handleInputChange}
              />
            </Box>
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="Localidad"
                value={userData.city}
                name="city"
                onChange={handleInputChange}
              />
            </Box>
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="Provincia"
                value={userData.province}
                name="province"
                onChange={handleInputChange}
              />
            </Box>
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="País"
                value={userData.country}
                name="country"
                onChange={handleInputChange}
              />
            </Box>
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="Correo Electrónico"
                value={userData.email}
                name="email"
                onChange={handleInputChange}
                disabled
              />
            </Box>
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="Usuario"
                value={userData.username}
                name="username"
                
              />
            </Box>
            <Box sx={{ width: "48%" }}>
              <TextField
                fullWidth
                label="Contraseña"
                type="password"
                value={userData.password}
                name="password"
                onChange={handleInputChange}
              />
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 3,
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              sx={{ borderRadius: 4 }}
              disabled={isLoading}
            >
              Guardar Cambios
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default UserProfilePage;
